import MunicipalityDataRoute from './data/index'

import Profile from 'js/pages/profile/index.js'

const meta = {
  layoutInfo: true,
  layout: 'default',
  auth: true
}

export default [
  {
    path: 'profile',
    name: 'municipality-profile',
    component: Profile,
    meta
  },
  ...normalizeRoutes(MunicipalityDataRoute)
]
